/** localStorage / sessionStorage that never throws (private mode, blocked storage). */
function make(kind: 'localStorage' | 'sessionStorage') {
  const store = (): Storage | null => {
    try {
      return typeof window !== 'undefined' ? window[kind] : null;
    } catch {
      return null;
    }
  };
  return {
    get<T>(key: string, fallback: T): T {
      try {
        const raw = store()?.getItem(key);
        return raw == null ? fallback : (JSON.parse(raw) as T);
      } catch {
        return fallback;
      }
    },
    set(key: string, value: unknown): void {
      try {
        store()?.setItem(key, JSON.stringify(value));
      } catch {
        /* ignore */
      }
    },
    remove(key: string): void {
      try {
        store()?.removeItem(key);
      } catch {
        /* ignore */
      }
    },
  };
}

export const local = make('localStorage');
export const session = make('sessionStorage');
